import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import moment from "moment";

import { API, urlBase } from "../APICalls";

import lebenRaffleIcon from "../assets/logo.png";
import SmallBox from "../components/SmallBox";
import NumberSelectionSimulator from "../components/NumberSelectionSimulator";
import LinkBox from "../components/LinkBox";
import ActionBox from "../components/ActionBox";
import FileUploader from "../components/FileUploader";

export default function Raffle() {
  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  document.getElementsByTagName("body")[0].classList.remove("login-page");
  document.getElementsByTagName("body")[0].classList.add("sidebar-mini");

  const [raffle, setRaffle] = useState(null);

  const [processingRaffle, setProcessingRaffle] = useState(false);

  const [downloadingOrigin, setDownloadingOrigin] = useState(false);
  const [downloadingWinners, setDownloadingWinners] = useState(false);
  const [downloadingBench, setDownloadingBench] = useState(false);

  const [raffleForm, setRaffleForm] = useState(null);
  const [raffleFormToken, setRaffleFormToken] = useState(null);
  const [editingRaffleForm, setEditingRaffleForm] = useState(false);
  const [raffleFormTitle, setRaffleFormTitle] = useState("");
  const [raffleFormDescription, setRaffleFormDescription] = useState("");
  const [raffleFormImageFile, setRaffleFormImageFile] = useState(null);
  const [raffleFormExpiresIn, setRaffleFormExpiresIn] = useState(0);
  const [downloadingRegistries, setDownloadingRegistries] = useState(false);

  var { raffleId } = useParams();

  useEffect(() => {
    API.GetRaffle(raffleId)
      .then((response) => {
        if (response.ok) {
          response.json().then((data) => {
            setRaffle(data);
          });
        } else {
          alert("Token is not valid");
        }
      })
      .catch(() => {
        alert("Cannot connect to LebenRaffle API");
      });
  }, []);

  useEffect(() => {
    API.GetForm(raffleId)
      .then((response) => {
        if (response.ok) {
          response.json().then((data) => {
            if (data && data.form) {
              setRaffleFormToken(data.token);
              setRaffleForm(data.form);
              setRaffleFormTitle(data.form.Title);
              setRaffleFormDescription(data.form.Description);
              setRaffleFormImageFile(data.form.ImageFile);
              setRaffleFormExpiresIn(data.form.ExpiresIn);
            }
          });
        }
      })
      .catch(() => {
        alert("Cannot connect to LebenRaffle API");
      });
  }, []);

  const processRaffle = () => {
    API.ProcessRaffle(raffleId)
      .then((response) => {
        if (response.ok) {
          response.json().then((data) => {
            setProcessingRaffle(true);
            setRaffle(data);
            sleep(3000).then(() => {
              setProcessingRaffle(false);
            });
          });
        } else {
          alert("Token is not valid");
        }
      })
      .catch(() => {
        alert("Cannot connect to LebenRaffle API");
      });
  };

  const resetRaffle = () => {
    API.ResetRaffle(raffleId)
      .then((response) => {
        if (response.ok) {
          response.json().then((data) => {
            setRaffle(data);
          });
        } else {
          alert("Token is not valid");
        }
      })
      .catch(() => {
        alert("Cannot connect to LebenRaffle API");
      });
  };

  const downloadBlob = (blob, filename) => {
    var url = window.URL.createObjectURL(blob);
    var a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
    a.click();
    a.remove(); //afterwards we remove the element again
  };

  const downloadOriginDatabase = () => {
    if (raffle != null && raffle.FileId != null) {
      setDownloadingOrigin(true);
      var filename = "download";
      API.GetRaffleResultFile(raffle.Id, "all")
        .then((response) => {
          filename = response.headers
            .get("Content-Disposition")
            .replace("attachment; filename=", "");
          return response.blob();
        })
        .then((blob) => {
          downloadBlob(blob, filename);
        })
        .finally(() => {
          setDownloadingOrigin(false);
        });
    }
  };

  const downloadWinnersDatabase = () => {
    if (raffle != null && raffle.FileId != null) {
      setDownloadingWinners(true);
      var filename = "download";
      API.GetRaffleResultFile(raffle.Id, "winners")
        .then((response) => {
          filename = response.headers
            .get("Content-Disposition")
            .replace("attachment; filename=", "");
          return response.blob();
        })
        .then((blob) => {
          downloadBlob(blob, filename);
        })
        .finally(() => {
          setDownloadingWinners(false);
        });
    }
  };

  const downloadBenchDatabase = () => {
    if (raffle != null && raffle.FileId != null) {
      setDownloadingBench(true);
      var filename = "download";
      API.GetRaffleResultFile(raffle.Id, "bench")
        .then((response) => {
          filename = response.headers
            .get("Content-Disposition")
            .replace("attachment; filename=", "");
          return response.blob();
        })
        .then((blob) => {
          downloadBlob(blob, filename);
        })
        .finally(() => {
          setDownloadingBench(false);
        });
    }
  };

  const saveRaffleForm = () => {
    if (raffleFormTitle === "" || raffleFormDescription === "") {
      alert("Es obligatorio completar título y descripción");
      return;
    }
    if (raffleForm && raffleForm.Id) {
      // edit
      API.EditForm(
        raffleForm.Id,
        raffleFormTitle,
        raffleFormDescription,
        raffleFormImageFile,
        raffleFormExpiresIn
      ).then((response) => {
        if (response.ok) {
          response.json().then((data) => {
            setRaffleForm(data.form);
            setRaffleFormToken(data.token);
            setEditingRaffleForm(false);
          });
        }
      });
    } else {
      API.CreateForm(
        raffleId,
        raffleFormTitle,
        raffleFormDescription,
        raffleFormImageFile,
        raffleFormExpiresIn
      ).then((response) => {
        if (response.ok) {
          response.json().then((data) => {
            setRaffleForm(data.form);
            setRaffleFormToken(data.token);
            setEditingRaffleForm(false);
          });
        }
      });
    }
  };

  const imageUploaded = (file) => {
    setRaffleFormImageFile(file.Id);
  };

  const [copyLinkButtonText, setCopyLinkButtonText] = useState("Copiar enlace");
  const onCopyLink = () => {
    navigator.clipboard.writeText(
      `${window.location.origin}/form/${raffleFormToken}`
    );

    // show text for 3 seconds
    setCopyLinkButtonText("¡Enlace copiado!");
    setTimeout(() => {
      setCopyLinkButtonText("Copiar enlace");
    }, 1500);
  };

  const onOpenLink = () => {
    window.open(`${window.location.origin}/form/${raffleFormToken}`, "_blank");
  };

  const downloadFormRegistries = () => {
    if (raffle != null && raffleForm != null) {
      setDownloadingRegistries(true);
      var filename = "download";
      API.GetFormRegistriesFile(raffleForm.Id)
        .then((response) => {
          filename = response.headers
            .get("Content-Disposition")
            .replace("attachment; filename=", "");
          return response.blob();
        })
        .then((blob) => {
          downloadBlob(blob, filename);
        })
        .finally(() => {
          setDownloadingRegistries(false);
        });
    }
  };

  if (raffle == null) {
    return (
      <div className="preloader flex-column justify-content-center align-items-center">
        <img
          className="animation__shake"
          src={lebenRaffleIcon}
          alt="LebenRaffle Logo"
          height="60"
          width="60"
        />
      </div>
    );
  } else {
    return (
      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1 className="m-0">Sorteo: {raffle.Name}</h1>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <Link to="/">Home</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/raffles">Todos los sorteos</Link>
                  </li>
                  <li className="breadcrumb-item active">Sorteo</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-6">
                <div className="card card-primary card-outline">
                  <div className="card-header">
                    <h5 className="m-0">Detalles</h5>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-lg-4 col-6">
                        <SmallBox
                          text="# Participantes"
                          value={raffle.ParticipantNumber}
                          bgColorClass="bg-info"
                          icon="fas fa-users"
                        />
                      </div>
                      <div className="col-lg-4 col-6">
                        <SmallBox
                          text="# Ganadores"
                          value={
                            raffle.WinnerNumber + " + " + raffle.BenchNumber
                          }
                          bgColorClass="bg-success"
                          icon="fas fa-award"
                        />
                      </div>
                      <div className="col-lg-4 col-6">
                        <SmallBox
                          text="Fecha de registro"
                          value={moment(raffle.CreationDatetime).format(
                            "DD/MM/YYYY"
                          )}
                          bgColorClass="bg-warning"
                          icon="far fa-calendar-alt"
                        />
                      </div>
                      {raffle.FileId == null ? (
                        <></>
                      ) : (
                        <div className="col-lg-12 col-12">
                          {downloadingOrigin ? (
                            <SmallBox
                              text="Descargando fichero..."
                              value="Participantes"
                              bgColorClass="bg-teal"
                              icon="fas fa-file-csv"
                            />
                          ) : (
                            <ActionBox
                              text="Base de datos en CSV"
                              value="Participantes"
                              bgColorClass="bg-teal"
                              icon="fas fa-file-csv"
                              action={downloadOriginDatabase}
                              actionText="Descargar"
                            />
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="card card-success card-outline">
                  <div className="card-header">
                    <h5 className="m-0">Resultado</h5>
                  </div>
                  <div className="card-body">
                    {raffle.RaffleDatetime == null ? (
                      <>
                        <p className="lead">
                          Todavía no se ha realizado el sorteo
                        </p>
                        <hr />
                        <a
                          href="#"
                          onClick={processRaffle}
                          className="btn btn-primary"
                        >
                          Iniciar Sorteo
                        </a>
                      </>
                    ) : (
                      <>
                        {processingRaffle ? (
                          <NumberSelectionSimulator
                            numbers={raffle.WinnerNumber + raffle.BenchNumber}
                          />
                        ) : raffle.FileId == null ? (
                          <>
                            <h3 className="text-success">
                              Ganadores:{" "}
                              {raffle.RaffleResult.split(", ")
                                .slice(0, raffle.WinnerNumber)
                                .join(", ")}
                            </h3>
                            <h3 className="text-muted">
                              Suplentes:{" "}
                              {raffle.RaffleResult.split(", ")
                                .slice(raffle.WinnerNumber)
                                .join(", ")}
                            </h3>
                          </>
                        ) : (
                          <div className="row">
                            <div className="col-lg-6 col-6">
                              {downloadingWinners ? (
                                <SmallBox
                                  text="Descargando fichero..."
                                  value="Ganadores"
                                  bgColorClass="bg-success"
                                  icon="fas fa-file-csv"
                                />
                              ) : (
                                <ActionBox
                                  text="Base de datos en CSV"
                                  value="Ganadores"
                                  bgColorClass="bg-success"
                                  icon="fas fa-file-csv"
                                  action={downloadWinnersDatabase}
                                  actionText="Descargar"
                                />
                              )}
                            </div>
                            <div className="col-lg-6 col-6">
                              {downloadingBench ? (
                                <SmallBox
                                  text="Descargando fichero..."
                                  value="Suplentes"
                                  bgColorClass="bg-secondary"
                                  icon="fas fa-file-csv"
                                />
                              ) : (
                                <ActionBox
                                  text="Base de datos en CSV"
                                  value="Suplentes"
                                  bgColorClass="bg-secondary"
                                  icon="fas fa-file-csv"
                                  action={downloadBenchDatabase}
                                  actionText="Descargar"
                                />
                              )}
                            </div>
                          </div>
                        )}
                        <hr />
                        <p className="lead">
                          {moment(raffle.CreationDatetime).format(
                            "[Sorteo realizado el ] DD/MM/YYYY [ a las ] HH:mm"
                          )}
                        </p>
                        <hr />
                        {processingRaffle ? (
                          <a href="#" className="btn disabled btn-primary">
                            Procesando Sorteo...
                          </a>
                        ) : (
                          <></>
                          // <a href="#" onClick={resetRaffle} className="btn btn-danger">Reiniciar Sorteo</a>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <div className="card card-info card-outline">
                  <div className="card-header">
                    <h5 className="m-0">Formulario de confirmación</h5>
                  </div>
                  {!raffleForm && !editingRaffleForm && (
                    <div className="card-body">
                      <p className="lead">
                        No se ha creado un formulario de confirmación para este
                        sorteo. Puedes configurar uno a continuación.
                      </p>
                      <button
                        type="button"
                        className="btn btn-block btn-outline-danger btn-lg"
                        onClick={() => setEditingRaffleForm(true)}
                      >
                        Configurar Formulario
                      </button>
                    </div>
                  )}
                  {raffleForm && !editingRaffleForm && (
                    <div className="card-body">
                      <div className="row">
                        <div className="col-lg-6">
                          <h3>{raffleForm.Title}</h3>
                          <strong>
                            {raffleForm.ExpiresIn === 0
                              ? "El formulario no caduca"
                              : `Caduca después de ${raffleForm.ExpiresIn} días`}
                          </strong>
                          {raffleFormImageFile && (
                            <img
                              src={
                                urlBase +
                                "/api/PublicFile/" +
                                raffleFormImageFile
                              }
                              className="img-fluid"
                            />
                          )}
                          <p>{raffleForm.Description}</p>
                          <button
                            type="button"
                            className="btn btn-block btn-outline-danger btn-lg"
                            onClick={() => setEditingRaffleForm(true)}
                          >
                            Editar Formulario
                          </button>
                        </div>
                        <div className="col-lg-6">
                          {raffleFormToken && (
                            <>
                              <div class="alert alert-info">
                                <h5>
                                  <i class="icon fas fa-info"></i> Enlace
                                </h5>
                                <p>
                                  Para compartir el formulario con los
                                  participantes, copia el siguiente enlace.
                                  Recuerda que este enlace es válido durante{" "}
                                  {raffleForm.ExpiresIn === 0
                                    ? "(no caduca)"
                                    : `${raffleForm.ExpiresIn} días`}{" "}
                                  desde hoy.
                                </p>
                                <strong>
                                  {window.location.origin}/form/
                                  {raffleFormToken}
                                </strong>
                                <div className="row mt-4">
                                  <div className="col-lg-6">
                                    <button
                                      type="button"
                                      className="btn btn-block btn-secondary"
                                      onClick={onCopyLink}
                                    >
                                      <i className="fas fa-copy mr-4"></i>
                                      {copyLinkButtonText}
                                    </button>
                                  </div>
                                  <div className="col-lg-6">
                                    <button
                                      type="button"
                                      className="btn btn-block btn-secondary"
                                      onClick={onOpenLink}
                                    >
                                      <i className="fas fa-external-link-alt mr-4"></i>
                                      Abrir en ventana nueva
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <button
                                type="button"
                                className="btn btn-block btn-outline-info"
                                onClick={downloadFormRegistries}
                              >
                                <i className="fa fa-download mr-4"></i>
                                Desgarcar registros de confirmación
                              </button>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                  {editingRaffleForm && (
                    <div className="card-body">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="form-group">
                            <label>Título</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Nombre del sorteo"
                              value={raffleFormTitle}
                              onChange={(e) =>
                                setRaffleFormTitle(e.target.value)
                              }
                            />
                          </div>
                        </div>
                        <div className="col-sm-12">
                          <div className="form-group">
                            <label>Días activo (0 no caduca) </label>
                            <input
                              type="number"
                              min={0}
                              className="form-control"
                              placeholder="0"
                              value={raffleFormExpiresIn}
                              onChange={(e) =>
                                setRaffleFormExpiresIn(e.target.value)
                              }
                            />
                          </div>
                        </div>
                        <div className="col-sm-12">
                          <div className="form-group">
                            <label>Imagen</label>
                            {raffleFormImageFile && (
                              <img
                                src={
                                  urlBase +
                                  "/api/PublicFile/" +
                                  raffleFormImageFile
                                }
                                className="img-fluid"
                              />
                            )}
                            <FileUploader onFileUploadDone={imageUploaded} />
                          </div>
                        </div>
                        <div className="col-sm-12">
                          <div className="form-group">
                            <label>Descripción</label>
                            <textarea
                              className="form-control"
                              placeholder={
                                "Escribe una descripción para mostrar en el formulario..."
                              }
                              rows={5}
                              value={raffleFormDescription}
                              onChange={(e) =>
                                setRaffleFormDescription(e.target.value)
                              }
                            />
                          </div>
                        </div>
                        <button
                          type="button"
                          className="btn btn-block btn-outline-danger btn-lg"
                          onClick={saveRaffleForm}
                        >
                          Guardar
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
